import React from 'react';
import { Dropdown, DropdownTheme } from 'wix-ui-tpa/cssVars';
import { dataHooks } from 'root/dataHooks';
import { useLocationsLogic } from './Locations.logic';
import type { LocationsList } from 'root/types/locations';
import { classes } from './Locations.st.css';
import { NavigationDropdownStyle } from 'root/consts';
import type { ILocation } from '@wix/yoshi-flow-editor';
import type { NavigateToFn } from 'root/clientTypes';

export type LocationsProps = {
  locations: LocationsList;
  currentLocation: string;
  setCurrentLocation: (location: string) => void;
  setActiveTab: (tab: number) => void;
  navigateTo?: NavigateToFn;
  currentUrl?: ILocation['url'];
};

export const Locations = ({
  locations,
  currentLocation,
  setCurrentLocation,
  setActiveTab,
  navigateTo,
  currentUrl,
}: LocationsProps) => {
  const { dropdownOptions, locationsDropdownStyle, onClickDropdownOption, t } = useLocationsLogic({
    locations,
    currentLocation,
    setCurrentLocation,
    navigateTo,
    currentUrl,
    setActiveTab,
  });
  return (
    <div className={classes.locationsContainer} data-hook={dataHooks.locations.container}>
      {dropdownOptions && (
        <Dropdown
          aria-label={t('component.menu.location.aria-label')}
          className={classes.dropdown}
          data-hook={dataHooks.locations.dropdown}
          flip={false}
          options={dropdownOptions}
          optionsContainerZIndex={2000}
          placement="bottom"
          selectedId={currentLocation}
          theme={locationsDropdownStyle === NavigationDropdownStyle.Box ? DropdownTheme.Box : DropdownTheme.Line}
          onChange={(option) => {
            onClickDropdownOption(option.id ?? '', option.value ?? '');
          }}
        />
      )}
    </div>
  );
};
